import { Alert } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
export function FormValidationErrors(props) {
    const { title } = props;
    const { errors, submitCount } = useFormikContext();
    if (submitCount === 0) {
        return null;
    }
    function collectErrors(err) {
        return Object.values(err).flatMap((value) => {
            if (!value) {
                return [];
            }
            if (typeof value === 'string') {
                return [value];
            }
            if (typeof value === 'object') {
                return collectErrors(value);
            }
            return [];
        });
    }
    const messages = collectErrors(errors);
    if (messages.length === 0) {
        return null;
    }
    return <Alert appearance="danger" title={title} message={messages.join(', ')}/>;
}
